import React, { lazy, Suspense } from 'react';
import { Loader } from '../../components/UI/Loader';
import { mockSiteVisit } from '../../consts/mockSiteVIsitData';

const SiteVisitProvider = lazy(() =>
  import('../../modules/SiteVisit').then(module => ({ default: module.SiteVisitProvider }))
);
const SiteVisitTool = lazy(() =>
  import('../../modules/SiteVisit').then(module => ({ default: module.SiteVisitTool }))
);

const SiteVisitPage: React.FC = () => {
  return (
    <Suspense fallback={<Loader />}>
      <SiteVisitProvider initialSiteVisit={mockSiteVisit}>
        <Suspense fallback={<Loader />}>
          <SiteVisitTool />
        </Suspense>
      </SiteVisitProvider>
    </Suspense>
  );
};

export default SiteVisitPage;
